import React from 'react';
import './mainServiceSection.css';
import { Link } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa6";

const MainServiceSection = ({ config }) => {
    const {
        imageUrl,
        eyebrow,
        title,
        heading,
        headingSpan,
        description,
        highlight,
        highlightSpan,
        button
    } = config;

    return (
        <section className="container-fluid ss-section">
            <div className="row">
                <div className='col-12 ss-content-headers line-height-clss'>
                    <span className='ss-name-span'>{eyebrow}</span>
                    <h1 className='ss-name line-height-clss'>{title}</h1>
                </div>
                <div
                    className="col-12 ss-content-data"
                >
                    <div className='ss-img'
                        style={{ backgroundImage: `url(${imageUrl})` }}
                    ></div>
                    <div className="ss-content">
                        <div className='ss-content-top'>

                            <h3 className="ss-heading"> <span>{headingSpan}</span><br />{heading}</h3>
                            <p className="ss-desc">{description}</p>
                        </div>
                        <div className='ss-content-bottom'>
                            {highlight && <p className="ss-highlight">  <span>{highlightSpan}</span>{highlight}</p>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 container-botton-reference'>
                    {button && (
                        <Link to="/contact" className="ss-button btn-general">
                            {button.text} 
                          <FaArrowRight className='card-arrow' />
                        </Link>
                    )}
                </div>
            </div>
        </section>
    );
};

export default MainServiceSection;
